import PropTypes from 'prop-types';

import styles from './TextIconESpot.module.scss';

const TextIconEspot = ({ icon, desc, alt, backgroundColor }) => (
  <div className={styles.container} data-test-id="text-icon-espot" style={{ backgroundColor }}>
    <img src={icon} alt={alt} width={16} height={16} />
    {desc}
  </div>
);

TextIconEspot.propTypes = {
  icon: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

export default TextIconEspot;
